import React, { useEffect, createElement } from 'react';
import { ProgressBar } from './components/ProgressBar';
import { TopBar } from './components/TopBar';
import { ArticleHeader } from './components/ArticleHeader';
import { HeroImage } from './components/HeroImage';
import { ArticleBody } from './components/ArticleBody';
import { Testimonials } from './components/Testimonials';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const PIXEL_ID = '1664420778222405';
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    w.fbq = fbq;
    if (!w._fbq) w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream flex flex-col selection:bg-gold/30 selection:text-burgundy" data-id="element-0">
      <ProgressBar data-id="element-1" />
      <TopBar data-id="element-2" />

      <main className="flex-grow" data-id="element-3">
        <ArticleHeader data-id="element-4" />
        <HeroImage data-id="element-5" />
        <ArticleBody data-id="element-6" />
        <Testimonials data-id="element-7" />
        <CallToAction data-id="element-8" />
      </main>

      <Footer data-id="element-9" />
    </div>;
}